import React from 'react';

import { Column } from 'components/Layout/Grid';

import warningImg from 'img/question-img.svg';

import { PageWarningProps } from './interface';

export const PageWarningByEmail: React.FC<PageWarningProps> = (props) => {

  const {
    title = ""
  } = props;

  return (
    <Column className="bg-white w-100 flex-1 h-100 align-center justify-center">
      <img src={warningImg} alt="" />
      <p className="color-blue-gray font-bold m-3 text-center" style={{
        fontSize: 18
      }}>
        {title}
      </p>
    </Column>
  );
};